import { useLang } from '@/pages/home/context/LanguageContext';

const content = {
  PT: {
    tag: 'Quem somos',
    title1: 'Mais do que um prestador de serviços —',
    titleHighlight: 'um parceiro estratégico',
    p1: 'A PAMIR Comércio e Serviços, Lda nasce com o compromisso de ser um parceiro técnico confiável para grandes operações industriais. Especializamo-nos em manutenção de sistemas AVAC e serviços técnicos industriais, com foco especial no setor petrolífero.',
    p2: 'A nossa missão é garantir a continuidade e segurança das atividades dos nossos clientes, contribuindo para a eficiência operacional e redução de custos através de manutenção preventiva de qualidade.',
    yearsLabel: 'Anos de excelência técnica industrial',
    values: [
      { icon: 'ri-shield-star-line', title: 'Segurança', desc: 'Operamos com os mais altos padrões de segurança industrial, protegendo pessoas e equipamentos.' },
      { icon: 'ri-medal-line', title: 'Profissionalismo', desc: 'Equipa altamente qualificada com formação contínua e certificações técnicas reconhecidas.' },
      { icon: 'ri-lightbulb-line', title: 'Inovação', desc: 'Adotamos as mais recentes tecnologias e metodologias para oferecer soluções eficientes.' },
      { icon: 'ri-shake-hands-line', title: 'Compromisso', desc: 'Parceiros de confiança que cumprem prazos e superam as expectativas dos nossos clientes.' },
    ],
  },
  EN: {
    tag: 'Who we are',
    title1: 'More than a service provider —',
    titleHighlight: 'a strategic partner',
    p1: 'PAMIR Comércio e Serviços, Lda was founded with the commitment to be a reliable technical partner for large industrial operations. We specialize in HVAC system maintenance and industrial technical services, with a special focus on the oil sector.',
    p2: 'Our mission is to ensure the continuity and safety of our clients\' activities, contributing to operational efficiency and cost reduction through quality preventive maintenance.',
    yearsLabel: 'Years of industrial technical excellence',
    values: [
      { icon: 'ri-shield-star-line', title: 'Safety', desc: 'We operate with the highest industrial safety standards, protecting people and equipment.' },
      { icon: 'ri-medal-line', title: 'Professionalism', desc: 'Highly qualified team with continuous training and recognized technical certifications.' },
      { icon: 'ri-lightbulb-line', title: 'Innovation', desc: 'We adopt the latest technologies and methodologies to offer efficient solutions.' },
      { icon: 'ri-shake-hands-line', title: 'Commitment', desc: 'Trusted partners who meet deadlines and exceed our clients\' expectations.' },
    ],
  },
};

export default function AboutSection() {
  const { lang } = useLang();
  const t = content[lang];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Images */}
          <div className="relative">
            <div className="w-full h-[480px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Group%20of%20Black%20African%20men%20and%20women%20professionals%20smiling%20and%20collaborating%20in%20a%20bright%20modern%20office%2C%20diverse%20team%20of%20engineers%20and%20managers%20gathered%20around%20a%20table%20with%20documents%20and%20laptops%2C%20warm%20natural%20lighting%2C%20confident%20expressions%2C%20clean%20white%20walls%20with%20industrial%20decor%20accents%2C%20photorealistic%20corporate%20photography%20Angola&width=700&height=500&seq=about009&orientation=landscape"
                alt="Equipa PAMIR"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-6 -right-6 bg-[#0B1A35] text-white rounded-2xl p-6 w-52">
              <div className="text-4xl font-extrabold text-[#F97316]">+2</div>
              <div className="text-sm text-white/70 mt-1">{t.yearsLabel}</div>
            </div>
            {/* Orange accent */}
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#F97316]/10 rounded-2xl -z-10" />
          </div>

          {/* Right: Content */}
          <div>
            <span className="text-[#F97316] text-sm font-semibold uppercase tracking-widest">
              {t.tag}
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-[#0B1A35] mt-2 mb-6 leading-tight">
              {t.title1}{' '}
              <span className="text-[#F97316]">{t.titleHighlight}</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">{t.p1}</p>
            <p className="text-gray-500 text-base leading-relaxed mb-10">{t.p2}</p>

            {/* Values Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {t.values.map((v) => (
                <div key={v.title} className="flex gap-4 items-start">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#F97316]/10 rounded-xl flex-shrink-0">
                    <i className={`${v.icon} text-[#F97316] text-xl`}></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-[#0B1A35] text-sm mb-1">{v.title}</h4>
                    <p className="text-gray-500 text-xs leading-relaxed">{v.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
